





















































import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    value: { type: Boolean },
  },
  setup(props, { root: { $store } }) {
    const namaPengguna = computed(() => $store.state.pengguna.namaPengguna);
    const isLogin = computed(() => $store.getters.isLogin);
    function keluar() {
      return $store.dispatch('pengguna/keluar');
    }

    const avatarUrl = computed(() => {
      const name = namaPengguna.value?.replace(' ', '+') || '';
      return `https://ui-avatars.com/api/?name=${name}&background=0D8ABC&color=fff&rounded=true&size=128`;
    });

    return {
      namaPengguna,
      isLogin,
      keluar,
      avatarUrl,
    };
  },
  data() {
    return {
      drawer: true,
      items: [
        { title: 'Home', icon: 'mdi-home' },
        { title: 'Format Code', icon: 'mdi-plus-box' },
        { title: 'Saved Code', icon: 'mdi-cards-outline' },
      ],
      mini: true,
    };
  },
});
